// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".alert-parent-case .v-alert__wrapper {\n  width: 100%;\n}\n.alert-parent-case .v-alert__wrapper .content {\n  font-size: 0.8rem;\n  line-height: 1.1rem;\n}\n.alert-parent-case .v-alert__wrapper .content .name {\n  font-size: 0.8rem;\n  font-weight: 600;\n}", ""]);
// Exports
module.exports = exports;
